module.exports = __webpack_public_path__ + "static/media/IHSA Logo.90876f23.png";